module.exports = __webpack_public_path__ + "static/media/ABOUT_LOGGING.6dfeb975.webp";